// extracted by mini-css-extract-plugin
export default {"saleWrapper":"KZ7tw","salePrice":"LK_36","salePriceValue":"j8joD"};